<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="任务ID">-->
<!--                  <el-input  v-model="queryForm.cronId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="执行结果">
                  <el-input  v-model="queryForm.executeResult"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getQuartzCronjobExecuteList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addQuartzCronjobExecute"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editQuartzCronjobExecute(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteQuartzCronjobExecute(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportQuartzCronjobExecuteList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshQuartzCronjobExecuteList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="quartzCronjobExecuteList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="id"-->
<!--        label="ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="cronId"-->
<!--        label="任务ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="executeResult"
        label="执行结果"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="添加时间"
        min-width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        fixed="right"-->
<!--        align="center"-->
<!--        label="操作"-->
<!--        width="300"-->
<!--      >-->
<!--        <template slot-scope="scop">-->
<!--          <div class="operation">-->
<!--            <div @click="checkQuartzCronjobExecute(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editQuartzCronjobExecute(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteQuartzCronjobExecute(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="quartzCronjobExecuteStates[quartzCronjobExecuteState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="quartzCronjobExecute"
          ref="quartzCronjobExecuteForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="任务ID"-->
<!--            prop="cronId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="quartzCronjobExecute.cronId"-->
<!--              :disabled="quartzCronjobExecuteState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="执行结果"
            prop="executeResult"
          >
            <el-input
              size="small"
              v-model="quartzCronjobExecute.executeResult"
              :disabled="quartzCronjobExecuteState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="quartzCronjobExecuteState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetQuartzCronjobExecuteList();
                    this.getQuartzCronjobExecuteList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetQuartzCronjobExecuteList();
                    this.getQuartzCronjobExecuteList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     cronId: '', //任务ID
                     executeResult: '', //执行结果
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                quartzCronjobExecuteState: 'add',
                quartzCronjobExecuteStates: {
                    add: '新建执行记录',
                    check: '查看执行记录',
                    edit: '修改执行记录'
                },

                multipleSelection: [],
                quartzCronjobExecuteList: [],
                quartzCronjobExecute: {
                    id: '', //ID
                    cronId: '', //任务ID
                    executeResult: '', //执行结果
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    cronId: [{ required: true, message: '任务ID不能为空', trigger: 'blur' }],
                    executeResult: [{ required: true, message: '执行结果不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getQuartzCronjobExecuteList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id){
                this.queryForm.cronId = id;
                this.quartzCronjobExecute.cronId = id;
                this.getQuartzCronjobExecuteList();
            },
            resetQuartzCronjobExecuteList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.quartzCronjobExecuteList = [];
            },
            resetDialog() {
                this.quartzCronjobExecuteState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      cronId: this.queryForm.cronId, //任务ID
                      executeResult: '', //执行结果
                };
                this.getQuartzCronjobExecuteList();
            },
            closeDialog() {
                this.showDialog = false
                this.quartzCronjobExecute = {
                      id: '', //ID
                      cronId: this.quartzCronjobExecute.cronId, //任务ID
                      executeResult: '', //执行结果
                };
            },
            submitForm() {
                if (this.quartzCronjobExecuteState == 'add') {
                    this.$refs.quartzCronjobExecuteForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/quartz/cronjobexecute/add`,{ ...this.quartzCronjobExecute }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetQuartzCronjobExecuteList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.quartzCronjobExecuteState == 'edit') {
                    this.$refs.quartzCronjobExecuteForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/quartz/cronjobexecute/edit`,{ ...this.quartzCronjobExecute }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetQuartzCronjobExecuteList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addQuartzCronjobExecute() {
                this.showDialog = true;
                this.quartzCronjobExecuteState = 'add';
            },
            checkQuartzCronjobExecute(quartzCronjobExecuteId) {
                console.log(quartzCronjobExecuteId);
                this.currentQuartzCronjobExecuteId = quartzCronjobExecuteId;

                this.getQuartzCronjobExecuteById();
                this.showDialog = true;
                this.quartzCronjobExecuteState = 'check';
            },
            editQuartzCronjobExecute(quartzCronjobExecuteId) {
                console.log('quartzCronjobExecute', quartzCronjobExecuteId);
                if (quartzCronjobExecuteId) {
                    this.currentQuartzCronjobExecuteId = quartzCronjobExecuteId;
                    this.getQuartzCronjobExecuteById();
                } else {
                    this.quartzCronjobExecute = { ...this.quartzCronjobExecute, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.quartzCronjobExecuteState = 'edit';
            },
            deleteQuartzCronjobExecute(quartzCronjobExecuteId) {
                let ids = '';
                if (quartzCronjobExecuteId) {
                    ids = quartzCronjobExecuteId;
                } else {
                    ids = this.multipleSelection.map((quartzCronjobExecute) => quartzCronjobExecute.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/quartz/cronjobexecute/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetQuartzCronjobExecuteList();
                                this.getQuartzCronjobExecuteList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshQuartzCronjobExecuteList() {
                this.resetQuartzCronjobExecuteList();
                this.getQuartzCronjobExecuteList();
            },
            getQuartzCronjobExecuteList(query = {}) {
                this.loading = true;
                get(`/quartz/cronjobexecute/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.quartzCronjobExecuteList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getQuartzCronjobExecuteById() {
                get(`/quartz/cronjobexecute/get`,{ id: this.currentQuartzCronjobExecuteId }).then((res) =>{
                    if(res.success){
                      this.quartzCronjobExecute = { ...this.quartzCronjobExecute, ...res.quartzCronjobExecute };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportQuartzCronjobExecuteList() {
                //this.btnLoading = true;
                exprotExcel(`/quartz/cronjobexecute/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/quartz/cronjobexecute/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/quartz/cronjobexecute/importData`,formData);
              this.refreshQuartzCronjobExecuteList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getQuartzCronjobExecuteList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getQuartzCronjobExecuteList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>